import { render, staticRenderFns } from "./NewsInDetail.vue?vue&type=template&id=05a00f9f&scoped=true&"
import script from "./NewsInDetail.vue?vue&type=script&lang=js&"
export * from "./NewsInDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewsInDetail.vue?vue&type=style&index=0&id=05a00f9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a00f9f",
  null
  
)

export default component.exports